import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Link, l } from '@manychat/manyui'

import { typedRouting } from 'utils/router'

import cm from '../StaticNotifications/StaticNotifications.module.css'

export const TiktokDirectReplyUnavailable = () => {
  const settingsLink = typedRouting.linkBuilder.settings({
    hash: 'tiktok',
    highlight_section: 'tiktok-high-intent-messages',
  })

  return (
    <div className="d-flex align-center gap-xxs">
      {l.translate('Turn on high-intent comments permission for TikTok.')}{' '}
      <Link as={RouterLink} to={settingsLink} className={cm.more}>
        {l.translate('Go to Settings')}
      </Link>
    </div>
  )
}
